// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type MaterialListe } from "../../api";
import { useFetchMaterialsByAbladestelleId as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export type FetchMaterialsByAbladestelleIdQuery = {
  search?: string;
  page?: number;
  limit?: number;
};

export function useFetchMaterialsByAbladestelleId(
  abladestelleId: string,
  query: FetchMaterialsByAbladestelleIdQuery = {},
  options: Omit<
    UseQueryOptions<MaterialListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): MaterialListe {
  const getter = useGetter();
  return useQuery(
    ["materialien", "abladestelle", abladestelleId, query],
    () => getter(abladestelleId, query),
    options
  ).data!;
}
